<template>
    <v-navigation-drawer
        class="sidebar-nav"
        dark
        permanent
        absolute
        left
      >
        <template v-slot:prepend>
          <v-list-item two-line>
            <v-list-item-avatar>
              <img src="https://randomuser.me/api/portraits/lego/2.jpg">
            </v-list-item-avatar>
  
            <v-list-item-content>
              <v-list-item-title>Admin</v-list-item-title>
              <v-list-item-subtitle>{{ accountEmail }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </template>
  
        <v-divider></v-divider>
        <v-list>
          <v-list-item
            v-for="(link, i) in links"
            :key="i"
            :to="link.to"
            :active-class="color"
             avatar
            class="v-list-item"
            >
            <v-list-item-icon>
              <v-icon>{{ link.icon }}</v-icon>
            </v-list-item-icon>
  
            <v-list-item-content>
              <v-list-item-title>{{ link.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        
      </v-navigation-drawer>
</template>

<script>
import i18n from '../../i18n'
export default {
    data () {
    return {
        accountEmail: localStorage.getItem('account-email'),
        links: [
          {
            to: `/${i18n.locale}/users`,
            icon: 'mdi-account-multiple',
            text: i18n.t('sidebar.users')
          },
          {
            to: `/${i18n.locale}/categories`,
            icon: 'mdi-arrange-bring-forward',
            text: i18n.t('sidebar.categories')
          },
          {
            to: `/${i18n.locale}/products`,
            icon: 'mdi-popcorn',
            text: i18n.t('sidebar.products')
          },
          {
            to: `/${i18n.locale}/mobile-layout`,
            icon: 'mdi-cellphone',
            text: i18n.t('sidebar.mobileLayout')
          },
          {
            to: `/${i18n.locale}/orders`,
            icon: 'mdi-gift',
            text: i18n.t('sidebar.orders')
          },
      ],
    }
  },
}
</script>

<style lang="less" scoped>
    .sidebar-nav{
        padding-top: 12px !important;
        background: #ff9f1c !important;
    }
    .v-list-item:hover{
      text-decoration: none;
    }
</style>